import type { WidgetDefinition } from '../WidgetDefinition';
import { faRadar } from '@fortawesome/pro-regular-svg-icons/faRadar';
import type { LocatesWidgetModel } from '@thinkalpha/ui-types/contracts/workspace';

class LocatesWidgetDefinition implements WidgetDefinition<LocatesWidgetModel, LocatesWidgetModel> {
    type = 'locates' as const;
    nameKey = 'widgets::locates::name' as const;
    roles = ['widgets::locates'];
    icon = faRadar;
    category = 'widgets::categories::trading' as const;

    /**
     * Converts a Locates widget from contract model to view model
     */
    toViewModel(widget: LocatesWidgetModel): LocatesWidgetModel {
        return {
            ...widget,
            quickSendButtons: widget.quickSendButtons ?? [],
        };
    }

    /**
     * Converts a Locates widget from view model to contract model
     */
    toContractModel(widget: LocatesWidgetModel): LocatesWidgetModel {
        return widget;
    }
}

export const locatesWidgetDefinition = new LocatesWidgetDefinition();
